module.exports = __webpack_public_path__ + "img/6.8af19890.png";